import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const STATUS = {
  Valid: { bg: "#DCFCE7", color: "#166534" },
  "Expiring Soon": { bg: "#FEF3C7", color: "#854D0E" },
  "Attention Required": { bg: "#FEF3C7", color: "#854D0E" },
  Expired: { bg: "#FEE2E2", color: "#7F1D1D" },
};

export default function Training() {
  const { data, siteNames } = useHSE();
  const summary = data.trainingSummary;
  const total = summary?.totalRequirements ?? data.trainings.length;
  const valid = summary?.validRecords ?? data.trainings.filter((t) => t.status === "Valid").length;
  const expired = summary?.expiredRecords ?? data.trainings.filter((t) => t.status === "Expired").length;
  const expiring = summary?.expiringSoonRecords ?? data.trainings.filter((t) => t.status === "Expiring Soon").length;
  const notRequired = summary?.notRequiredRecords ?? 0;
  const compliance = summary?.compliance ?? (total ? Math.round((valid / total) * 100) : 0);

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <Stat label="Compliance" value={`${compliance}%`} sub="Latest training matrix" tone={compliance >= 95 ? "safe" : "warning"} />
      <Stat label="Total Requirements" value={total.toLocaleString()} />
      <Stat label="Valid Records" value={valid.toLocaleString()} tone="safe" />
      <Stat label="Expired Records" value={expired.toLocaleString()} tone={expired > 0 ? "critical" : "safe"} />
      <Stat label="Not Required" value={notRequired.toLocaleString()} />
    </div>
  );

  return (
    <RegisterPage
      title="Training & Induction"
      subtitle="Latest training compliance summary from ZHONGYOUHAI-16 monthly report"
      storeKey="trainings"
      idPrefix="TRN"
      topPanels={Top}
      columns={[
        { key: "id", label: "ID" },
        { key: "employeeName", label: "Training / Certificate" },
        { key: "employeeId", label: "Required / Valid" },
        { key: "site", label: "Rig / Site" },
        { key: "department", label: "Category" },
        { key: "type", label: "Type" },
        { key: "trainer", label: "Source" },
        { key: "date", label: "Updated" },
        { key: "expiryDate", label: "Remarks" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS }}
      formFields={[
        { key: "id", label: "Training ID" },
        { key: "employeeName", label: "Training / Certificate" },
        { key: "employeeId", label: "Required / Valid" },
        { key: "site", label: "Rig / Site", type: "select", options: siteNames },
        { key: "department", label: "Category", type: "select", options: data.settings.departments },
        { key: "type", label: "Training Type", type: "select", options: ["Mandatory", "Induction", "Certification", "Operator Certification", "External"] },
        { key: "trainer", label: "Source / Provider" },
        { key: "date", label: "Last Updated", type: "date" },
        { key: "expiryDate", label: "Remarks" },
        { key: "status", label: "Status", type: "select", options: ["Valid", "Expiring Soon", "Attention Required", "Expired"] },
      ]}
    />
  );
}

function Stat({ label, value, sub, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
      {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}
